exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".top-copy[data-v-677bb646]{margin-bottom:45px}ul[data-v-677bb646]{list-style-type:none;padding:0}ul li[data-v-677bb646]{margin-bottom:5px}ul li a[data-v-677bb646]{font-size:20px}", "", {"version":3,"sources":["/opt/build/repo/src/views/notices/notices.styl"],"names":[],"mappings":"AACA,2BACE,kBAAoB,CACrB,AACD,oBACE,qBAAsB,AACtB,SAAiB,CAClB,AACD,uBACE,iBAAmB,CACpB,AACD,yBACE,cAAgB,CACjB","file":"notices.styl","sourcesContent":["\n.top-copy[data-v-677bb646] {\n  margin-bottom: 45px;\n}\nul[data-v-677bb646] {\n  list-style-type: none;\n  padding: 0 0 0 0;\n}\nul li[data-v-677bb646] {\n  margin-bottom: 5px;\n}\nul li a[data-v-677bb646] {\n  font-size: 20px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-677bb646","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./src/views/notices/notices.styl
// module id = ErU+
// module chunks = 20